;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.inbox.show')
    .controller('InboxShowToolbarController', InboxShowToolbarController)

  InboxShowToolbarController.$inject = ['inmail']

  function InboxShowToolbarController (inmail) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        inmail: inmail,
        title: inmail.raw.title
      })
    }
  }
})(window.angular, window._)
